const COMMENT_CREATED_JUST_NOW = "comment.just_now";

const FLAG_DELETED = "deleted";
const FLAG_SPOILER = "spoiler";
const VOTE_LIKE = "like";

export { COMMENT_CREATED_JUST_NOW, FLAG_DELETED, FLAG_SPOILER, VOTE_LIKE };
